import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Icon } from '../Icon';

const CheckboxContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  box-sizing: border-box;

  align-items: center;
  justify-content: center;
  border-radius: 2px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  border: ${({ $checked }) =>
    $checked ? '1px solid transparent' : '1px solid var(--border-default)'};

  background: ${({ $checked }) => ($checked ? 'var(--primary-default)' : 'transparent')};
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

const Checkbox = ({ onChange, value, checked = false, className = null }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleCheckboxChange = (evt) => {
    const nextState = !isChecked;
    setIsChecked(nextState);
    onChange({ value, evt });
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <CheckboxContainer $checked={isChecked} onClick={handleCheckboxChange} className={className}>
      <HiddenCheckbox checked={isChecked} onChange={handleCheckboxChange} />
      {isChecked && <Icon name='check' size={16} color='var(--white)' />}
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  className: PropTypes.string
};

export { Checkbox };
